import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { TenantDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { TenantForm } from './TenantForm';
import { PVAPage } from '../../components';

export class TenantCreate extends React.Component<BaseRouteProps<{}>, {}> {
    private tenantDataService = new TenantDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.save = this.save.bind(this);
    }

    public render() {
        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <NavLink to={`/tenant`}>
                            <span className="glyphicon glyphicon-triangle-left" />
                        </NavLink>
                        &nbsp;
                        Create Tenant
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <TenantForm submit={this.save} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.tenantDataService.create(values).then((success) => {
            this.props.history.push('/tenant');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/tenant/TenantCreate.tsx